import axios from '@/utils/fetch'
import dm from 'kkt-domain'

/*
* 团期列表
*/

// 获取目的国列表
export function getMarketcity (params) {
  return axios.post('/marketing/marketcity/indexajax', params)
}

// 获取出发口岸列表
export function getPorts (params) {
  return axios.post('/resources/city/listajax', params)
}

// 获取团期列表
export function getListforsale (params) {
  return axios.get('/groups/planinfo/listforwxajax', {params})
}

// 获取当前登陆用户信息
export function getCurrentUserInfo (params) {
	return axios.get('/user/manager/userinfo', {params})
}

/*
* 团期详情
*/

// 获取单个团期详情
export function getSingleDetail (params) {
  return axios.get('/groups/planinfo/detailforwxajax', {params})
}

// 获取活动团期信息
export function getGroupMeeting (params) {
  return axios.get(dm.get('shareapi') + '/operate/meetingsale/detailajax', {params})
}

// 获取客户列表
export function getCustomerList (params) {
	return axios.get('/customer/customercontact/search', {params})
}

// 新建订单
export function createOrder (data) {
	return axios.post('/sale/order/add', data)
}

// 订单详情
export function orderDetail (params) {
	return axios.get('/sale/order/detail', {params})
}

// 获取团期名类似的团期
export function getListforwx (params) {
	return axios.get('/groups/planinfo/listforwxajax', {params})
}

// 信息转发
export function createShare (data) {
	return axios.post('/share/share/add', data)
}

/*
* 分享
*/

// 获取分享详情
export function getShareDetail (params) {
	return axios.get('/share/share/detail', {params})
}

// 获取分享列表
export function getShareList (params) {
	return axios.get('/share/share/search', {params})
}

/*
* 获取留位清单
*/
export function getLeaveAll (params) {
  return axios.get('/sale/order/searchall', { params })
}

// 获取团期dm单张详细数据
export function getGroupDmDetail (params) {
  return axios.get('/dm/dmgroup/search', { params })
}

// 获取出团通知书
export function getNoticeFiles (params) {
	return axios.get('/dm/dmattach/search', { params })
}


// WEBPACK FOOTER //
// ./src/api/exposure.js